import {browser, btn, comp, Component, EntityID, h3, h4, router, splitter, t, tbar} from "@intermesh/goui";
import {boardgrid, BoardGrid} from "./BoardGrid.js";
import {BoardDialog} from "./BoardDialog.js";
import {columngrid, ColumnGrid} from "./ColumnGrid.js";

export class Main extends Component {
	private readonly west: Component;

	private boardGrid!: BoardGrid;
	private columnGrid!: ColumnGrid;

	constructor() {
		super();

		this.cls = "hbox fit";

		this.items.add(
			this.west = this.createWest(),
			splitter({resizeComponent: this.west, stateId: "kanban-west-splitter"}),
			this.createCenter()
		);

		this.on("render", () => {
			void this.boardGrid.store.load();
		});

		this.boardGrid.store.on("load", () => {
			if (this.boardGrid.store.data.length && this.boardGrid.rowSelection!.getSelected().length === 0) {
				this.boardGrid.rowSelection!.selectNext();
			}
		});
	}

	private createWest(): Component {
		return comp({
				itemId: "west",
				stateId: "kanban-sidebar",
				width: 300,
				minWidth: 140,
				cls: "scroll"
			},
			tbar({},
				h4({text: t("Boards")}),
				"->",
				btn({
					cls: "small",
					icon: "add",
					disabled: !go.Modules.get("business", "kanban").userRights.mayManageBoards,
					handler: () => {
						const dlg = new BoardDialog();
						dlg.show();
					}
				}),

				btn({
					cls: "small",
					title: t("Close sidebar"),
					icon: "left_panel_close",
					handler: (button, ev) => {
						this.west.hidden = true;
						this.west.saveState();
					}
				})
			),
			this.boardGrid = boardgrid({
				flex: 1,
				cls: "no-row-lines",
				headers: false,
				rowSelectionConfig: {
					multiSelect: false,
					listeners: {
						selectionchange: ({target}) => {
							const boardId = target.getSelected().map((row) => row.record.id)[0]!;
							router.goto("kanban/" + boardId);
						}
					}
				}
			})
		);
	}

	private createCenter(): Component {
		return this.columnGrid = columngrid({west: this.west});
	}

	public async load(id?: EntityID) {
		if (id) {
			await this.boardGrid.store.load();
			const board = this.boardGrid.store.find((r: any) => r.id == id);

			if (board) {
				this.boardGrid.rowSelection!.clear()
				this.boardGrid.rowSelection!.add(board);
			}

			void this.columnGrid.load(id);
		}
	}
}
